// Manages right-click anchor state for TaskContextMenu on a task row.
import { useState, useCallback } from 'react';

/**
 * @param {object} options
 * @param {import('@/features/tasks/components/context-menu/taskContextMenuConfig').TaskContextMenuSurface|null|undefined} options.menuSurface
 * @param {boolean} [options.enabled]
 */
export function useTaskItemContextMenu({ menuSurface, enabled = true }) {
  const [menuState, setMenuState] = useState(
    /** @type {{ task: import('@/types').Task, mouseX: number, mouseY: number }|null} */ (
      null
    ),
  );

  const handleContextMenu = useCallback(
    (task, event) => {
      if (!enabled || !menuSurface || !task) return;
      event.preventDefault();
      event.stopPropagation();
      setMenuState({ task, mouseX: event.clientX, mouseY: event.clientY });
    },
    [enabled, menuSurface],
  );

  const closeMenu = useCallback(() => {
    setMenuState(null);
  }, []);

  return {
    menuState,
    handleContextMenu,
    /** @type {() => void} */
    closeMenu,
    isMenuOpen: Boolean(menuState),
  };
}
